import { iDataCenterDoc, iProProjectMain } from "@/app/models/interfaceProject";
import { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import Modal from "../Elements/Modal";
import { ChevronDown } from "lucide-react";
import { DataCenterDoc, FormatExtensions, OriginFile, TypeFile, TypeLayout } from "@/app/constants/enums";
import { useUser } from "@/app/context/UserContext";
import { getExcelQa } from "@/app/helpers/excel";
import { Constantes } from "@/app/constants/constantsGlobal";
import { iParamFile } from "@/app/models/drive";

interface DatacenterUploadProps {
    isOpen: boolean;
    onClose: () => void;
    onUpload: (data: any) => void;
    paramQa?:boolean;
    paramFile?:iParamFile|null;
}

export default function DatacenterUpload({ isOpen, onClose, onUpload, paramQa, paramFile}: DatacenterUploadProps) {
  const { typeLayout, setTypeLayout,
          userProject, setUserProject,
          addAlert
        } = useUser();

  const [qa, setQa] = useState(false); 
  const [file, setFile] = useState<File | null>(null);
  const [files, setFiles] = useState<File[]>([]);
  const [search_answer, setSearchAnswer]= useState(false);
  const [consult_reference, setConsultReference]= useState(false);
  const [columns, setColumns] = useState<string[]>([]);
  const [showOpcionesXlsx, setShowOpcionesXlsx] = useState(false);
  //const [showColumns, setShowColumns] = useState(false);
  const [selectedColumn, setSelectedColumn] = useState("");
  const [errorfile, setErrorfile] = useState("");

  const fileInputRef = useRef<HTMLInputElement | null>(null);
  useEffect(() => {
    if (isOpen) {
       requestAnimationFrame(() => {
        fileInputRef.current?.click();
      });
    }
    if (!isOpen) {
      setFiles([]);
      setFile(null);
      setColumns([]);
      setShowOpcionesXlsx(false);
      setQa(paramQa??false);
      //setShowColumns(false);
      setSelectedColumn("");
      setErrorfile(``);
    }

    if(isOpen && paramFile){
      if (paramFile.file_origin==OriginFile.Drive) {
        const selectedFile = paramFile.file;
        if (selectedFile.size > Constantes.MAX_FILE_PDF_EXCEL_SIZE) { 
          setErrorfile("El archivo supera el límite de "+(Constantes.MAX_FILE_PDF_EXCEL_SIZE/1024/1024)+"MB" )
          resetValue();
          return;
        }
        setFile(selectedFile);
        if (selectedFile.name.endsWith(".xls") || selectedFile.name.endsWith(".xlsx")) {
            setShowOpcionesXlsx(true);
            readExcelColumns(selectedFile);
        } else {
            setShowOpcionesXlsx(false);
            setColumns([]);
        }
        setFiles([selectedFile]);
        setSelectedColumn("");
        setErrorfile("");
      }
    }
  }, [isOpen]);

  const resetValue=()=>{
    setFile(null);
    setFiles([]);
    setColumns([]);
    setShowOpcionesXlsx(false);
    setSelectedColumn("");
  };

  const handleFile = (selectedFile: File) => {
    if (!selectedFile) return;

    if (selectedFile.size > Constantes.MAX_FILE_PDF_EXCEL_SIZE) { 
      setErrorfile("El archivo supera el límite de "+(Constantes.MAX_FILE_PDF_EXCEL_SIZE/1024/1024)+"MB" )
      resetValue();
      return;
    }
      
    //if (qa) {
    const isValid = FormatExtensions[typeLayout].some(ext => selectedFile.name.endsWith(ext)); 
    if (!isValid) {
      setErrorfile(`Formato no permitido. Solo se aceptan archivos: ${FormatExtensions[typeLayout].join(", ")}`) 
      resetValue();
      return;
    }

    if(qa && !(selectedFile.name.endsWith(".xls") || selectedFile.name.endsWith(".xlsx"))){
      setErrorfile(`Formato no permitido. Solo se aceptan archivos: ${FormatExtensions[typeLayout].join(", ")}`) 
      resetValue();
      return; 
    }
    setErrorfile(``) 
    //} 

    // const allowedExtensions = ["pdf", "xls", "xlsx"];
    // if (!allowedExtensions.includes(selectedFile.type)) {
    //   alert("Formato no permitido. Solo se aceptan archivos Excel (.xls, .xlsx) y PDF (.pdf).");
    //   return;
    // } 
    
    setFile(selectedFile);

    if (selectedFile.name.endsWith(".xls") || selectedFile.name.endsWith(".xlsx")) {
        setShowOpcionesXlsx(true);
        readExcelColumns(selectedFile);
    } else {
        setShowOpcionesXlsx(false);
        setColumns([]);
    }
  };

  const handleFilesDrive = (selectedFiles: File[]) => {
    let validFiles: File[] = [];

    for (let i = 0; i < selectedFiles.length; i++) {
      const selectedFile = selectedFiles[i];
      if (selectedFile.size > Constantes.MAX_FILE_PDF_EXCEL_SIZE) {
        setErrorfile(`El archivo ${selectedFile.name} supera el límite de ${(Constantes.MAX_FILE_PDF_EXCEL_SIZE / 1024 / 1024)}MB`);
        continue;
      }
      const isValid = FormatExtensions[typeLayout].some(ext => selectedFile.name.endsWith(ext));
      if (!isValid) {
        setErrorfile(`Formato no permitido en ${selectedFile.name}. Solo se aceptan archivos: ${FormatExtensions[typeLayout].join(", ")}`);
        continue;
      }
      if (qa && !(selectedFile.name.endsWith(".xls") || selectedFile.name.endsWith(".xlsx"))) {
        setErrorfile(`Formato inválido en ${selectedFile.name}. Solo se aceptan archivos Excel para este modo.`);
        continue;
      }
      validFiles.push(selectedFile);

      // Solo ejecuta para el primer archivo XLS/XLSX
      if (i === 0 && (selectedFile.name.endsWith(".xls") || selectedFile.name.endsWith(".xlsx"))) {
        setShowOpcionesXlsx(true);
        readExcelColumns(selectedFile);
      }
    }

    if (validFiles.length > 0) {
      setErrorfile('');
      setFiles(validFiles);
    }
  };


  const handleFiles2 = (selectedFiles: File[]) => {
    let validFiles: File[] = [];

    for (let i = 0; i < selectedFiles.length; i++) {
      const selectedFile = selectedFiles[i];
      if (selectedFile.size > Constantes.MAX_FILE_PDF_EXCEL_SIZE) {
        setErrorfile(`El archivo ${selectedFile.name} supera el límite de ${(Constantes.MAX_FILE_PDF_EXCEL_SIZE / 1024 / 1024)}MB`);
        continue;
      }
      const isValid = FormatExtensions[typeLayout].some(ext => selectedFile.name.endsWith(ext));
      if (!isValid) {
        setErrorfile(`Formato no permitido en ${selectedFile.name}. Solo se aceptan archivos: ${FormatExtensions[typeLayout].join(", ")}`);
        continue;
      }
      if (qa && !(selectedFile.name.endsWith(".xls") || selectedFile.name.endsWith(".xlsx"))) {
        setErrorfile(`Formato inválido en ${selectedFile.name}. Solo se aceptan archivos Excel para este modo.`);
        continue;
      }
      validFiles.push(selectedFile);

      // Solo ejecuta para el primer archivo XLS/XLSX
      if (i === 0 && (selectedFile.name.endsWith(".xls") || selectedFile.name.endsWith(".xlsx"))) {
        setShowOpcionesXlsx(true);
        readExcelColumns(selectedFile);
      }
    }

    if (validFiles.length > 0) {
      setErrorfile('');
      setFiles(validFiles);
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files?.[0]) {
      handleFile(event.target.files[0]);
    }
  };

  const handleFileChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = event.target.files;
    if (!selectedFiles) return;

    const filesArray = Array.from(selectedFiles);
    handleFiles2(filesArray);
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (event.dataTransfer.files.length > 0) {
      handleFile(event.dataTransfer.files[0]);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const readExcelColumns = (file: File) => {
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const firstRow = XLSX.utils.sheet_to_json(sheet, { header: 1 })[0] as string[]; 
      if (Array.isArray(firstRow)) {
        setColumns(firstRow);
        setSelectedColumn(firstRow[0]);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleUpload = async() => {
    if (!file) {
      setErrorfile(`Por favor, seleccione un archivo válido.`) 
      return;
    }
    setErrorfile(``);
    // viene de preguntas y respuestas
    if (paramQa){
      const qaData = await getExcelQa(file);  
      onUpload(qaData);
      return;
    }

    // viene de listado y editar 
    if(qa){
      const qaData = await getExcelQa(file);  
      setUserProject((prevProject: iProProjectMain) => ({
            ...prevProject,
            qa: [
                ...qaData,
                ...(prevProject.qa || [])
            ],
        }));  
    }

    const data: iDataCenterDoc = { 
      file_id_local: crypto.randomUUID(),
      chunk_overlap: DataCenterDoc.chunk_overlap,
      chunk_size: DataCenterDoc.chunk_size,
      deleted: false,        
      file_type:file?.type,
      file_size: file?.size,
      type:  (qa?TypeFile.Qa:((file?.name.endsWith(".pdf") || file?.name.endsWith(".PDF") )?TypeFile.Pdf:TypeFile.Excel)),
      name: file?.name,
      columns: columns,
      embedded_column: selectedColumn,
      file: file || undefined 
    }; 
    onUpload(data);
  };
  const getLabel = () => {
    if (qa) return "Pregunta y Respuesta";
    if (search_answer) return "Búsqueda y respuesta";
    if (consult_reference) return "Consulta y referencia";
    return "Subir Fuente";
  };
  const handleUpload2 = async () => {
    if (!files || files.length === 0) {
      setErrorfile(`Por favor, seleccione al menos un archivo válido.`);
      return;
    }

    setErrorfile('');

    for (const file of files) {
      // viene de preguntas y respuestas
      if (paramQa) {
        const qaData = await getExcelQa(file);
        onUpload(qaData);
        continue;
      }

      if (qa) {
        const qaData = await getExcelQa(file);
        setUserProject((prevProject: iProProjectMain) => ({
          ...prevProject,
          qa: [...(qaData || []), ...(prevProject.qa || [])],
        }));
      }

      const data: iDataCenterDoc = {
        file_id_local: crypto.randomUUID(),
        chunk_overlap: DataCenterDoc.chunk_overlap,
        chunk_size: DataCenterDoc.chunk_size,
        deleted: false,
        file_type: file.type,
        file_size: file.size,
        type: qa
          ? TypeFile.Qa
          : file.name.toLowerCase().endsWith('.pdf')
          ? TypeFile.Pdf
          : TypeFile.Excel,
        name: file.name,
        columns: columns,
        embedded_column: selectedColumn,
        
        file_origin: paramFile?paramFile.file_origin:OriginFile.Device,        
        drive_id:paramFile&&paramFile.file_origin==OriginFile.Drive?paramFile.meta_data.id:"",        
        drive_mime_type: paramFile&&paramFile.file_origin==OriginFile.Drive?paramFile.meta_data.mimeType:"",
        drive_version: paramFile&&paramFile.file_origin==OriginFile.Drive?paramFile.meta_data.version:"",
        drive_modified_time: paramFile&&paramFile.file_origin==OriginFile.Drive?paramFile.meta_data.modifiedTime:"",
        drive_url: paramFile&&paramFile.file_origin==OriginFile.Drive?paramFile.meta_data.drive_url:"",
        file,
      }; 
      onUpload(data);
    }
    setFiles([]);
    setShowOpcionesXlsx(false);
    setColumns([]);
    setSelectedColumn('');
  };


  const ShowColumnSelect = showOpcionesXlsx && !qa && !search_answer && !consult_reference;


    


  return (
    <Modal isOpen={isOpen} onClose={onClose}>
        <div className="p-4 w-[800px]">
            <h2 className="text-lg font-semibold mb-5"> {getLabel()}</h2> 
            <div
                className="border-dashed rounded-3xl border-2 border-gray-300 p-6 text-center mb-4 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50"
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                onClick={() => fileInputRef.current?.click()}
            >

                {files.length > 0 ? (
                  <ul className="text-green-500">
                    {files.map((f, idx) => (
                      <li key={idx}>{f.name}</li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-gray-500">Arrastra un archivo aquí o haz clic para seleccionar</p>
                )}
            </div>

            <input
                ref={fileInputRef}
                type="file"
                accept={FormatExtensions[typeLayout].join(", ")}
                onChange={handleFileChange2}
                className="hidden"
                multiple
            />
            {/* Errores */}
            {errorfile && (
                <p className="text-red-500 text-sm">{errorfile}</p>
              )}
            <div>
            {/* 
            <div className="mt-2 flex justify-between items-center">
              {(showOpcionesXlsx || paramQa) && (
                <label className="w-full flex items-center gap-2">
                  <input
                    type="checkbox"
                    className="border w-5 h-5 focus:outline-none focus:ring-1 focus:ring-blue-700"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const checked = e.target.checked;
                      setSearchAnswer(checked);
                      setConsultReference(false);
                      setQa(false);
                    }}
                    checked={search_answer}
                    disabled={paramQa}
                  />
                  <span className="text-gray-700">Búsqueda y respuestas automáticas</span>
                </label>
              )}

              {(showOpcionesXlsx || paramQa) && (
                <label className="w-full flex items-center gap-2">
                  <input
                    type="checkbox"
                    className="border w-5 h-5 focus:outline-none focus:ring-1 focus:ring-blue-700"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const checked = e.target.checked;
                      setConsultReference(checked);
                      setSearchAnswer(false);
                      setQa(false);
                    }}
                    checked={consult_reference}
                    disabled={paramQa}
                  />
                  <span className="text-gray-700">Documento de consulta y referencia</span>
                </label>
              )}
            </div>
            */}
            </div>
            <div className="mt-2 flex justify-between items-center">
              {(showOpcionesXlsx || paramQa) && (
                  <label className="w-full flex items-center gap-2">
                    <input
                      type="checkbox"
                      className="border w-5 h-5 focus:outline-none focus:ring-1 focus:ring-blue-700"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        const checked = e.target.checked;
                        setQa(checked);
                        setSearchAnswer(false);
                        setConsultReference(false);
                      }}
                      checked={paramQa}
                      disabled={paramQa}
                    />
                    <span className="text-gray-700">¿Archivo de preguntas y respuestas?</span>
                </label> 
              )} 
              {ShowColumnSelect && (
                        <div className="w-full">
                          <label className="block text-gray-700">Columna Principal</label>                    
                          <div className="relative"> 
                              <select 
                                  className= {`appearance-none w-full border n-fmr-input px-4 pr-4 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700`}
                                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setSelectedColumn(e.target.value)}>
                              {columns.map((col, index) => (
                                  <option key={index} value={col}>{col}</option>
                              ))}
                              </select>
                              <ChevronDown className="w-5 h-5 absolute inset-y-0 top-3 right-3 pointer-events-none text-gray-400" /> 
                          </div>
                        </div> 
              )}
            </div>
            <div className="flex items-center justify-end mt-5"> 
                <button
                    type="button"
                    onClick={()=>{resetValue();onClose();}}
                    className="bg-gray-200 hover:bg-gray-300 text-gray-700  py-2 px-4 mr-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                    >
                    Cancelar
                    </button>
                    <button
                        type="button"
                        onClick={handleUpload2}
                        className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                    >
                    Agregar
                    </button>
            </div>

 
        </div>
    </Modal>

  );
}
